import { produce } from 'immer';
import { create } from 'zustand';
import { ContainerPort, HeadlessServicePort, HeadlessServiceYaml } from '../types';

interface HeadlessServiceYamlState {
  serviceYamlData: HeadlessServiceYaml;
}

interface HeadlessServiceYamlAction {
  /** 生成服务名称 */
  setYamlServiceName: (serviceName: string) => void;
  /** 基础信息 */
  updateYamlServiceBase: (appName: string) => void;
  /** 映射端口信息 */
  updateYamlServicePort: (ports: HeadlessServicePort[]) => void;
  reset: () => void;
}

const initHeadlessServiceYaml: HeadlessServiceYamlState = {
  serviceYamlData: {
    apiVersion: 'v1',
    kind: 'Service',
    metadata: {
      name: undefined,
      labels: {
        app: undefined,
      },
      annotations: {
        'stack.io/aliase': undefined,
        'stack.io/statefulset': undefined, // statefulset 的名称
      },
    },
    spec: {
      sessionAffinity: 'None',
      clusterIP: 'None',
      ports: undefined,
      selector: {
        app: undefined,
      },
    },
  },
};

export const useHeadlessServiceYamlStore = create<
  HeadlessServiceYamlState & HeadlessServiceYamlAction
>()((set) => ({
  ...initHeadlessServiceYaml,
  setYamlServiceName: (serviceName: string) => {
    set(
      produce((state: HeadlessServiceYamlState) => {
        state.serviceYamlData.metadata.name = serviceName;
      }),
    );
  },
  updateYamlServiceBase: (appName) => {
    set(
      produce((state: HeadlessServiceYamlState) => {
        state.serviceYamlData.metadata.labels.app = appName;
        state.serviceYamlData.spec.selector.app = appName;
        state.serviceYamlData.metadata.annotations['stack.io/aliase'] = appName;
        state.serviceYamlData.metadata.annotations['stack.io/statefulset'] = appName;
      }),
    );
  },
  updateYamlServicePort: (ports: ContainerPort[]) => {
    set(
      produce((state: HeadlessServiceYamlState) => {
        state.serviceYamlData.spec.ports = ports;
      }),
    );
  },
  reset: () => set(initHeadlessServiceYaml),
}));
